import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export enum ECategory {
  deposit = 'deposit',
  withdrawal = 'withdrawal',
  mining = 'mining',
  invoice = 'invoice',
  electricity_fee = 'electricity_fee',
  electricity_fee_deposit = 'electricity_fee_deposit',
  electricity_fee_cashback = 'electricity_fee_cashback',
  affiliate = 'affiliate',
}

export const TransactionHistoryResponseSchema = z
  .object({
    count: z.number(),
    initial_date: z.number().or(z.string()),
    data: z
      .record(
        z.string(),
        z.array(
          z.object({
            time: z.string(),
            datetime: z.string(),
            id: z.number(),
            title: z.string(),
            category: z.nativeEnum(ECategory),
            status: z.number().or(z.string()).or(z.null()),
            amount: z.number().or(z.string()),
            balance: z.number().or(z.string()),
            coin: z.string(),
          }),
        ),
      )
      .or(z.array(z.NEVER)),
  })
  .transform(transformKeysToCamelCase)
  .transform((data) => {
    return {
      data: {
        ...data,
        transactionHistoryData: Object.values(data.data).flat(),
      },
    };
  });

export type TTransactionHistoryResponse = z.infer<typeof TransactionHistoryResponseSchema>;
export type TTransactionHistoryData = Omit<TTransactionHistoryResponse['data'], 'data'>;
export type TTransactionHistoryDataTransaction =
  TTransactionHistoryResponse['data']['transactionHistoryData'];
